import React from 'react';
import styled from 'styled-components';
import { BlackTaskCircle } from '../../Constants/assets';
// Stylings
const CircleContainer = styled.div`
    position: absolute;
    z-index: 1;
`;
const TextContainer = styled.div`
    display: flex;
    justify-content: center;
    text-align: -webkit-center;
    align-items: center;
`;
const ParagraphContainer = styled.div`
    height: 250px;
    display: flex;
    align-items: center;
`;
const CircleText = styled.div`
    font-weight: normal;
    font-size: 1rem;
    line-height: 22px;
    color: ${props => props.theme.colors.white};
    position: relative;
    width: 241px;
    left: 50%;
`;
const BottomContainer = styled.div`
    opacity: 0.5;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-radius: 8px;
    width: 38px;
`;
export default function CircleTask({ paragraphText, taskNumber }) {
    return (
        <CircleContainer>
            <TextContainer>
                <CircleText>
                    <ParagraphContainer>{paragraphText}</ParagraphContainer>
                    <BottomContainer>{taskNumber}</BottomContainer>
                </CircleText>
                <BlackTaskCircle />
            </TextContainer>
        </CircleContainer>
    );
}
